import { useQuery } from '@tanstack/react-query';

import { QUERY_STALE_TIME, isSupabaseConfigured } from '@/config';
import { useAuth } from '@/lib/auth/AuthProvider';
import { getCoinsLeaderboard, getWeeklyChallenges } from '@/lib/data/provider';
import { queryKeys } from '@/lib/data/keys';

/**
 * The caller's Predict & Win weekly challenges (this ISO week) with live
 * progress, rewards, and rolled-up earnings. Keyed by user so a sign-in/out
 * swaps the cached progress. Anonymous users see the catalogue at zero progress.
 */
export function useWeeklyChallenges() {
  const { userId } = useAuth();
  return useQuery({
    queryKey: queryKeys.weeklyChallenges(userId ?? 'anon'),
    queryFn: getWeeklyChallenges,
    staleTime: QUERY_STALE_TIME.user,
    enabled: isSupabaseConfigured,
  });
}

/** The seasonal coins leaderboard (top N + the caller's own rank). */
export function useCoinsLeaderboard(enabled = true) {
  return useQuery({
    queryKey: queryKeys.coinsLeaderboard,
    queryFn: () => getCoinsLeaderboard(),
    staleTime: QUERY_STALE_TIME.user,
    enabled: isSupabaseConfigured && enabled,
  });
}
